var _rect, _rect2, _g, _g2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2, _g3, _g4, _path3, _tspan, _tspan2, _path4, _tspan3, _path5, _path6, _tspan4, _g5, _path7, _tspan5, _path8, _path9, _tspan6, _path10, _path11, _tspan7, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 300,
    viewBox: "0 0 105.83 79.375",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.546,
    y: 4.9541,
    width: 23.683,
    height: 3.7042,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#241c56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.212,
    y: 2.0242,
    width: 48.179,
    height: 75.71,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.34414
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "submit",
    transform: "matrix(1.3007 0 0 1.3007 -2.2456 -3.301)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.817,
    y: 54.894,
    width: 19.012,
    height: 5.5571,
    rx: 0.40684,
    ry: 0.40684,
    fill: "#0200ff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 36.434986,
    y: 58.642395,
    fill: "#ffffff",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "2.6445px",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 36.434986,
    y: 58.642395,
    fill: "#ffffff",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "2.6445px",
    strokeWidth: 0.26458
  }, "SUBMIT")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "upload-i",
    transform: "matrix(.0075316 0 0 .0075316 46.985 55.622)",
    fill: "#f210ef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m798.01 421.41-169.74-169.69c-15.625-15.625-40.969-15.625-56.555 0l-169.73 169.69 56.605 56.555 101.41-101.4v423.43h79.992v-423.43l101.45 101.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m880 720v160.01h-559.99v-160.01h-80.004v160.01c0 43.98 36.012 79.992 80.004 79.992h559.99c43.992 0 80.004-36.012 80.004-79.992v-160.01z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.473,
    y: 51.575,
    width: 13.229,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#ffc34c"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.52,
    y: 55.35,
    width: 43.735,
    height: 9.3218,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stopColor: "#000000",
    stroke: "#fa9ef9",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.723,
    y: 45.902,
    width: 18.521,
    height: 2.9104,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#46991f"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.505,
    y: 45.355,
    width: 3.8452,
    height: 3.8452,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stopColor: "#000000",
    stroke: "#46991f",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.473,
    y: 41.704,
    width: 31.75,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#ffc34c"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30.53,
    y: 34.712,
    width: 43.715,
    height: 4.4833,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#ff5252",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346
  })), /*#__PURE__*/React.createElement("text", {
    className: "bday-p",
    x: 31.810261,
    y: 38.079994,
    fill: "#babfc3",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.0972px",
    letterSpacing: ".34414px",
    strokeMiterlimit: 10,
    strokeWidth: 0.34104,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, "--/--/----"), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30.473,
    y: 31.242,
    width: 15.875,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#ffc34c"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.53,
    y: 24.388,
    width: 43.715,
    height: 4.4833,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stopColor: "#000000",
    stroke: "#5352ff",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30.363,
    y: 20.78,
    width: 11.906,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#ffc34c"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3d4193"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.363,
    y: 16.306,
    width: 31.66,
    height: 2.409,
    rx: 0.52917,
    ry: 0.52917,
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.363,
    y: 13.209,
    width: 44.049,
    height: 2.409,
    rx: 0.52917,
    ry: 0.52917,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.363,
    y: 10.111,
    width: 44.049,
    height: 2.409,
    rx: 0.52917,
    ry: 0.52917,
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.344 14.413h-6.5698v-7.6069h16.099",
    fill: "none",
    stroke: "#ccc",
    strokeDasharray: "1.19063, 1.5875",
    strokeMiterlimit: 10,
    strokeWidth: 0.39688
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m22.576 10.61h-6.7336",
    fill: "none",
    stroke: "#ccc",
    strokeDasharray: "1.19063, 1.5875",
    strokeMiterlimit: 10,
    strokeWidth: 0.39688
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.0056735 0 0 .0056735 5.9455 7.0469)",
    fill: "#3d4193"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m87.5 250v-50h312.5v800h-50c-17.863 0-34.371 9.5312-43.301 25-8.9336 15.469-8.9336 34.531 0 50 8.9297 15.469 25.438 25 43.301 25h200c17.863 0 34.371-9.5312 43.301-25 8.9336-15.469 8.9336-34.531 0-50-8.9297-15.469-25.438-25-43.301-25h-50v-800h300v50c0 17.863 9.5312 34.371 25 43.301 15.469 8.9336 34.531 8.9336 50 0 15.469-8.9297 25-25.438 25-43.301v-100c0-13.262-5.2695-25.98-14.645-35.355s-22.094-14.645-35.355-14.645h-812.5c-13.262 0-25.98 5.2695-35.355 14.645s-14.645 22.094-14.645 35.355v100c0 17.863 9.5312 34.371 25 43.301 15.469 8.9336 34.531 8.9336 50 0 15.469-8.9297 25-25.438 25-43.301z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1150 550h-400c-13.262 0-25.98 5.2695-35.355 14.645s-14.645 22.094-14.645 35.355v87.5c0 17.863 9.5312 34.371 25 43.301 15.469 8.9336 34.531 8.9336 50 0 15.469-8.9297 25-25.438 25-43.301v-37.5h100v350h-25c-17.863 0-34.371 9.5312-43.301 25-8.9336 15.469-8.9336 34.531 0 50 8.9297 15.469 25.438 25 43.301 25h150c17.863 0 34.371-9.5312 43.301-25 8.9336-15.469 8.9336-34.531 0-50-8.9297-15.469-25.438-25-43.301-25h-25v-350h100v25c0 17.863 9.5312 34.371 25 43.301 15.469 8.9336 34.531 8.9336 50 0 15.469-8.9297 25-25.438 25-43.301v-75c0-13.262-5.2695-25.98-14.645-35.355s-22.094-14.645-35.355-14.645z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ccc",
    strokeDasharray: "1.19062, 1.5875",
    strokeMiterlimit: 10,
    strokeWidth: 0.39688
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.774 52.898 7.0924 5.3e-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.774 43.027 7.0924-1e-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.774 32.721 7.0924-1e-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.774 22.103 7.0924-1e-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.774 52.898v-30.796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.576 37.233h-6.7336"
  }))), /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.801 36.954-1.3024-1.8234c-0.077-0.10894-0.20188-0.17396-0.3353-0.17457h-3.741c-0.11024 0-0.21598 0.0438-0.29391 0.12176-0.07797 0.07793-0.12176 0.18368-0.12176 0.29391v3.3253c0 0.11023 0.04382 0.21597 0.12176 0.29391 0.07797 0.07796 0.18367 0.12176 0.29391 0.12176h3.741c0.13438 2.93e-4 0.26052-0.06483 0.33807-0.17457l1.3024-1.8234c0.01593-0.0239 0.0242-0.0521 0.02367-0.0808-4.76e-4 -0.02871-0.0097-0.0566-0.02649-0.07995z",
    fill: "#fa0",
    strokeWidth: 0.0057731
  })), /*#__PURE__*/React.createElement("text", {
    x: 6.354372,
    y: 42.624821,
    fill: "#ffaa00",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "2.9104px",
    strokeDasharray: "1.19063, 1.5875",
    strokeMiterlimit: 10,
    strokeWidth: 0.39688,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 6.354372,
    y: 42.624821,
    fill: "#ffaa00",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "2.9104px",
    strokeWidth: 0.39688
  }, "Label"))), /*#__PURE__*/React.createElement("text", {
    x: 3.6212406,
    y: 16.787043,
    fill: "#3d4193",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "2.9104px",
    strokeDasharray: "1.19063, 1.5875",
    strokeMiterlimit: 10,
    strokeWidth: 0.39688,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 3.6212406,
    y: 16.787043,
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "2.9104px",
    strokeWidth: 0.39688
  }, "Plain Text")))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15.842 64.14h6.9321v7.5725h15.669",
    fill: "none",
    stroke: "#ccc",
    strokeDasharray: "1.19062, 1.5875",
    strokeMiterlimit: 10,
    strokeWidth: 0.39688
  })), /*#__PURE__*/React.createElement("text", {
    x: 5.8935513,
    y: 69.714218,
    fill: "#0200ff",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "2.9104px",
    strokeDasharray: "1.19063, 1.5875",
    strokeMiterlimit: 10,
    strokeWidth: 0.39688,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 5.8935513,
    y: 69.714218,
    fill: "#0200ff",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "2.9104px",
    strokeWidth: 0.39688
  }, "Button"))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m9.917 66.814c-1.5343 0-2.7781-1.2438-2.7781-2.7781 0-1.5343 1.2438-2.7781 2.7781-2.7781 1.5343 0 2.7781 1.2438 2.7781 2.7781 0 1.5343-1.2438 2.7781-2.7781 2.7781zm-0.45813-3.8205c-0.01873-0.01206-0.04051-0.01846-0.06273-0.01846-0.06396 0-0.11575 0.0518-0.11575 0.11576v1.8902c0 0.02222 0.0061 0.044 0.01846 0.06273 0.03465 0.05372 0.10629 0.06921 0.16003 0.03456l1.4649-0.94511c0.01382-9e-3 0.02564-0.02074 0.03456-0.03448 0.03465-0.05372 0.01916-0.12538-0.03456-0.16003z",
    fill: "#0200ff",
    fillRule: "evenodd",
    strokeWidth: 0.0046302
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m75.428 60.011h6.5065v4.7919h6.8792",
    fill: "none",
    stroke: "#ccc",
    strokeDasharray: "1.19062, 1.5875",
    strokeMiterlimit: 10,
    strokeWidth: 0.39688
  })), /*#__PURE__*/React.createElement("text", {
    x: 87.457985,
    y: 71.228325,
    fill: "#f210ef",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "2.9104px",
    strokeDasharray: "1.19063, 1.5875",
    strokeMiterlimit: 10,
    strokeWidth: 0.39688,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 87.457985,
    y: 71.228325,
    fill: "#f210ef",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "2.9104px",
    strokeWidth: 0.39688
  }, "File Upload"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.007717 0 0 .007717 89.952 60.12)",
    fill: "#f210ef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m798.01 421.41-169.74-169.69c-15.625-15.625-40.969-15.625-56.555 0l-169.73 169.69 56.605 56.555 101.41-101.4v423.43h79.992v-423.43l101.45 101.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m880 720v160.01h-559.99v-160.01h-80.004v160.01c0 43.98 36.012 79.992 80.004 79.992h559.99c43.992 0 80.004-36.012 80.004-79.992v-160.01z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m56.663 47.357h25.272l5.2e-5 2.4442h6.879",
    fill: "none",
    stroke: "#ccc",
    strokeDasharray: "1.19062, 1.5875",
    strokeMiterlimit: 10,
    strokeWidth: 0.39688
  })), /*#__PURE__*/React.createElement("text", {
    x: 88.581108,
    y: 55.261974,
    fill: "#46991f",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "2.9104px",
    strokeDasharray: "1.19063, 1.5875",
    strokeMiterlimit: 10,
    strokeWidth: 0.39688,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 88.581108,
    y: 55.261974,
    fill: "#46991f",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "2.9104px",
    strokeWidth: 0.39688
  }, "Checkbox"))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m97.295 47.05c-0.0723 0.0037-0.1425 0.03665-0.19168 0.08967-0.58704 0.61421-1.8897 2.0098-2.5726 2.7291l-0.75086-0.66293c-0.1105-0.09761-0.29983-0.08589-0.39745 0.02461-0.0976 0.1105-0.0858 0.29982 0.0246 0.39743l0.95657 0.84409c0.108 0.09523 0.2914 0.08697 0.39037-0.0176 0.62932-0.65843 2.1361-2.2762 2.7573-2.9261 0.0791-0.08036 0.10227-0.21058 0.0558-0.31328-0.0464-0.10273-0.15953-0.17132-0.27212-0.165zm-4.9958 0.50997v3.939c4e-5 0.14732 0.13404 0.28135 0.28135 0.28135h3.9389c0.14733-2.1e-5 0.28136-0.13403 0.28136-0.28135v-1.9695c3e-3 -0.14866-0.13269-0.28536-0.28136-0.28536-0.14865 0-0.28344 0.1367-0.28135 0.28536v1.6881h-3.3762v-3.3763h2.9824c0.14866 0.0021 0.28536-0.13269 0.28536-0.28135s-0.1367-0.28344-0.28536-0.28135h-3.2637c-0.15558 0.0019-0.27821 0.16276-0.28134 0.28135z",
    fill: "#46991f",
    strokeWidth: 0.0074461
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m75.428 36.954h6.5065v-4.7625h6.8791",
    fill: "none",
    stroke: "#ccc",
    strokeDasharray: "1.19062, 1.5875",
    strokeMiterlimit: 10,
    strokeWidth: 0.39688
  })), /*#__PURE__*/React.createElement("text", {
    x: 87.6604,
    y: 38.130203,
    fill: "#ff0000",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "2.9104px",
    strokeDasharray: "1.19063, 1.5875",
    strokeMiterlimit: 10,
    strokeWidth: 0.39688,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 87.6604,
    y: 38.130203,
    fill: "#ff0000",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "2.9104px",
    strokeWidth: 0.39688
  }, "Date Select"))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m96.305 29.498h-1.1339v-0.22679c0-0.12518-0.1016-0.22678-0.22678-0.22678s-0.22678 0.1016-0.22678 0.22678v0.22679h-1.1339v-0.22679c0-0.12518-0.10161-0.22678-0.22678-0.22678-0.12518 0-0.22679 0.1016-0.22679 0.22678v0.22679h-0.71275c-0.17373 0-0.34107 0.073-0.46401 0.20524-0.11703 0.1261-0.18393 0.29685-0.18393 0.47511v4.0821c0 0.17827 0.0669 0.34901 0.18393 0.47511 0.12291 0.13222 0.29028 0.20524 0.46401 0.20524h5.0541c0.17373 0 0.34107-0.073 0.46401-0.20524 0.11703-0.1261 0.18393-0.29685 0.18393-0.47511v-4.0821c0-0.17827-0.0669-0.34901-0.18393-0.47511-0.12291-0.13222-0.29028-0.20524-0.46401-0.20524h-0.71277v-0.22679c0-0.12518-0.1016-0.22678-0.22678-0.22678s-0.22678 0.1016-0.22678 0.22678zm1.3607 1.8143v2.9482c0 0.0624-0.0218 0.12246-0.0628 0.16645-0.0349 0.0376-0.0819 0.0603-0.13154 0.0603h-5.0541c-0.0497 0-0.0966-0.0227-0.13153-0.0603-0.0411-0.044-0.0628-0.10409-0.0628-0.16645v-2.9482zm-4.5356 2.4946h0.45357c0.12518 0 0.22678-0.10161 0.22678-0.22679s-0.1016-0.22678-0.22678-0.22678h-0.45357c-0.12517 0-0.22678 0.1016-0.22678 0.22678s0.10161 0.22679 0.22678 0.22679zm1.5875 0h0.45356c0.12518 0 0.22678-0.10161 0.22678-0.22679s-0.1016-0.22678-0.22678-0.22678h-0.45356c-0.12518 0-0.22679 0.1016-0.22679 0.22678s0.10161 0.22679 0.22679 0.22679zm1.5875 0h0.45356c0.12518 0 0.22679-0.10161 0.22679-0.22679s-0.10161-0.22678-0.22679-0.22678h-0.45356c-0.12518 0-0.22679 0.1016-0.22679 0.22678s0.10161 0.22679 0.22679 0.22679zm-3.175-1.3607h0.45357c0.12518 0 0.22678-0.10161 0.22678-0.22679 0-0.12517-0.1016-0.22678-0.22678-0.22678h-0.45357c-0.12517 0-0.22678 0.10161-0.22678 0.22678 0 0.12518 0.10161 0.22679 0.22678 0.22679zm1.5875 0h0.45356c0.12518 0 0.22678-0.10161 0.22678-0.22679 0-0.12517-0.1016-0.22678-0.22678-0.22678h-0.45356c-0.12518 0-0.22679 0.10161-0.22679 0.22678 0 0.12518 0.10161 0.22679 0.22679 0.22679zm1.5875 0h0.45356c0.12518 0 0.22679-0.10161 0.22679-0.22679 0-0.12517-0.10161-0.22678-0.22679-0.22678h-0.45356c-0.12518 0-0.22679 0.10161-0.22679 0.22678 0 0.12518 0.10161 0.22679 0.22679 0.22679zm0.45356-2.4946v0.22679c0 0.12517-0.1016 0.22678-0.22678 0.22678s-0.22678-0.10161-0.22678-0.22678v-0.22679h-1.1339v0.22679c0 0.12517-0.1016 0.22678-0.22678 0.22678s-0.22678-0.10161-0.22678-0.22678v-0.22679h-1.1339v0.22679c0 0.12517-0.10161 0.22678-0.22678 0.22678-0.12518 0-0.22679-0.10161-0.22679-0.22678v-0.22679h-0.71275c-0.0497 0-0.0966 0.0227-0.13154 0.0603-0.0411 0.044-0.0628 0.10408-0.0628 0.16644v0.68035h5.4428v-0.68035c0-0.0624-0.0218-0.12246-0.0628-0.16644-0.0349-0.0377-0.0819-0.0603-0.13154-0.0603z",
    fill: "#f00",
    fillRule: "evenodd",
    strokeWidth: 0.0060476
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m75.428 26.63h6.5065v-13.141h6.8791",
    fill: "none",
    stroke: "#ccc",
    strokeDasharray: "1.19062, 1.5875",
    strokeMiterlimit: 10,
    strokeWidth: 0.39688
  })), /*#__PURE__*/React.createElement("text", {
    x: 88.780922,
    y: 18.857952,
    fill: "#0200ff",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "2.9104px",
    strokeDasharray: "1.19063, 1.5875",
    strokeMiterlimit: 10,
    strokeWidth: 0.39688,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 88.780922,
    y: 18.857952,
    fill: "#0200ff",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "2.9104px",
    strokeWidth: 0.39688
  }, "Text Input"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.0078395 0 0 .0078395 90.631 8.8523)",
    fill: "#0200ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m180 705c-8.2812 0-15 6.7188-15 15s6.7188 15 15 15h120c8.2812 0 15-6.7188 15-15s-6.7188-15-15-15h-45v-210h45c8.2812 0 15-6.7188 15-15s-6.7188-15-15-15h-120c-8.2812 0-15 6.7188-15 15s6.7188 15 15 15h45v210z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1110 360h-1020c-16.57 0-30 13.43-30 30v420c0 16.57 13.43 30 30 30h1020c16.57 0 30-13.43 30-30v-420c0-16.57-13.43-30-30-30zm-30 420h-960v-360h960z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormWidget);
export default __webpack_public_path__ + "static/media/form-widget.4a41c7777981d5b3985befa96429062d.svg";
export { ForwardRef as ReactComponent };